import { combineReducers } from 'redux';
import { createNewInvoiceFail, createNewInvoiceRequest, createNewInvoiceSuccess } from '../actions';
import { BillingAction } from '../types';

const createInvoiceLoading = (state = false, action: BillingAction) => {
  switch (action.type) {
    case createNewInvoiceRequest.type:
      return true;

    case createNewInvoiceSuccess.type:
    case createNewInvoiceFail.type:
      return false;

    default:
      return state;
  }
};

export default combineReducers({
  createInvoiceLoading,
});
